import * as types from "./types"

export function checkNotAuthenticated() {
  return {
    type: types.CHECK_NOT_AUTHENTICATED
  }
}

export function validateVerifCode(code) {
  return {
    type: types.VALIDATE_VERIF_CODE,
    code
  }
}

export function resetVerifCode() {
  return {
    type: types.VERIF_CODE_RESET
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/account.js